export const DEFAULT_ZEROCASE_LABEL = 'No records for this period';

export enum ChartTypes {
  Highcharts = 'Highcharts',
  Highstock = 'Highstock',
  Highmaps = 'Highmaps',
}

export enum MapCollectionTypes {
  World = 'World',
  US = 'US',
}

// Chart types that HighchartsReact component accept as a constructorType prop
export const CHART_CONSTRUCTOR_TYPES = {
  [ChartTypes.Highcharts]: 'chart',
  [ChartTypes.Highstock]: 'stockChart',
  [ChartTypes.Highmaps]: 'mapChart',
  ganttChart: 'ganttChart',
};
